import { useEffect, useState } from "react";
import { Check, ChevronsUpDown, UserPlus, CheckCircle2, ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { Input } from "./ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";

export const NamePicker = ({ value, onChange, reloadKey }) => {
  const [names, setNames] = useState([]);
  const [open, setOpen] = useState(false);
  const [manual, setManual] = useState(false);

  useEffect(() => { api.get("/roster").then(({ data }) => setNames(data)).catch(() => {}); }, [reloadKey]);
  useEffect(() => { setManual(false); }, [reloadKey]);

  const addNew = () => { setOpen(false); setManual(true); onChange(""); };

  if (manual) return (
    <div className="space-y-2">
      <Input required autoFocus value={value} onChange={(e) => onChange(e.target.value)} placeholder="Type your full name" className="h-12 text-base" data-testid="contribution-name-input" />
      <button type="button" onClick={() => { setManual(false); onChange(""); }} data-testid="name-picker-back" className="text-xs font-semibold text-amber-800 inline-flex items-center gap-1"><ArrowLeft className="h-3.5 w-3.5" />Back to the list</button>
    </div>
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="name-picker-trigger" className={`w-full h-12 px-3 rounded-md border border-input bg-transparent text-base flex items-center justify-between ${value ? "text-stone-900" : "text-muted-foreground"}`}>
          <span className="truncate">{value || "Search and select your name"}</span>
          <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[--radix-popover-trigger-width] p-0" data-testid="name-picker-popover">
        <Command>
          <CommandInput placeholder="Type to search..." data-testid="name-picker-search" />
          <CommandList className="max-h-64">
            <CommandEmpty className="py-4 text-center text-sm text-stone-500">No match found.</CommandEmpty>
            <CommandGroup>
              {names.map((n) => (
                <CommandItem key={n.id} value={n.name} onSelect={() => { onChange(n.name); setOpen(false); }} data-testid={`name-option-${n.id}`}>
                  <Check className={`h-4 w-4 ${value === n.name ? "opacity-100" : "opacity-0"}`} />
                  <span className="flex-1 truncate">{n.name}</span>
                  {n.contributed && <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-teal-700" data-testid={`name-contributed-${n.id}`}><CheckCircle2 className="h-3.5 w-3.5" />Contributed</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
          <button type="button" onClick={addNew} data-testid="name-picker-add-new" className="w-full border-t border-stone-200 px-3 py-3 text-sm font-semibold text-amber-800 hover:bg-amber-50 inline-flex items-center gap-2">
            <UserPlus className="h-4 w-4" />Can't find my name? Add new name
          </button>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
